<template>
  <section class="your-plan">
    <div class="container container--mw-lg">
      <h2 class="your-plan__heading">Your Plan</h2>

      <div class="your-plan__block">
        <h3 v-if="activePlan" class="your-plan__block-active-plan">
          {{ activePlan }}
        </h3>
        <p v-if="creditBalance" class="body-copy your-plan__block-copy">
          You have {{ creditBalance }} remaining search{{
            creditBalance === 1 ? "" : "es"
          }}
        </p>

        <AppButton :text="buttonText" :link="buttonLink" />
      </div>
    </div>
  </section>
</template>

<script>
// import planMixin from "@/mixins/planMixin";
import AppButton from "@/components/ui/AppButton";
import axios from "axios";

export default {
  name: "YourPlan",
  data() {
    return {
      activePlan: null,
      creditBalance: null,
    };
  },
  computed: {
    buttonText: function () {
      if (this.activePlan) {
        return "View Activity";
      }

      return "Activate your Plan";
    },
    buttonLink: function () {
      if (this.activePlan) {
        return "/my-account/manage-plan";
      }

      return "/my-account/manage-plan/top-up";
    },
  },
  methods: {
    fetchActivePlan() {
      const userId = sessionStorage.getItem("user_id");
      axios({
        method: "post",
        url: `${process.env.VUE_APP_API_ROOT_URL}/api/getactiveplan`,
        data: {
          userId,
        },
        headers: {
          "Content-Type": "application/json",
        },
      })
        .then((response) => {
          if (
            response.data.activePlan !== undefined &&
            response.data.activePlan.length > 0
          ) {
            this.activePlan = response.data.activePlan;
          } else {
            this.activePlan = "No Active Plan";
          }
        })
        .catch((error) => {
          this.activePlan = "No Active Plan";
          console.error(error);
        });
    },

    fetchUserCredits() {
      const userId = sessionStorage.getItem("user_id");
      axios({
        method: "post",
        url: `${process.env.VUE_APP_API_ROOT_URL}/api/getCredits`,
        data: {
          userId,
        },
        headers: {
          "Content-Type": "application/json",
        },
      })
        .then((response) => {
          this.creditBalance = response.data.credits;
          // console.log(this.creditBalance);
        })
        .catch((error) => {
          console.error(error);
        });
    },
  },
  created() {
    this.fetchActivePlan();
    this.fetchUserCredits();
  },
  components: {
    AppButton,
  },
};
</script>
